import { createAction, emptyProps, props } from '@ngrx/store';
import { IReservationItem, OutlookReservationMode } from '@outlook-addin/cue-http';
import { IReservationDetail } from '@outlook-addin/cue-http';

export const loadReservationList = createAction('[Reservation] Load ReservationList', props<{ filter: any }>());

export const reservationListLoaded = createAction(
  '[Reservation] ReservationList Loaded',
  props<{ reservationList: IReservationItem[] }>()
);

export const loadEventDetailFromGraph = createAction(
  '[Reservation] Load EventDetail from Graph',
  props<{ itemId: string }>()
);

export const refreshReservationDetail = createAction('[Reservation] Refresh ReservationDetail', emptyProps);

export const hideReservationDetailResources = createAction(
  '[Reservation] Hide ReservationDetail Resources',
  props<{ resourceIds: number[] }>()
);

export const showReservationDetailResources = createAction(
  '[Reservation] Show ReservationDetail Resources',
  props<{ resourceIds: number[] }>()
);

export const dismissResourceRemovalConfirmation = createAction(
  '[Reservation] Dismiss Resource Removal Confirmation',
  props<{ resourceId: number }>()
);

export const clearDismissedResourceRemovalConfirmations = createAction(
  '[Reservation] Clear Dismissed Resource Removal Confirmations',
  emptyProps
);

export const startReservationLocationChange = createAction(
  '[Reservation] Start Reservation Location Change',
  emptyProps
);

export const cancelReservationLocationChange = createAction(
  '[Reservation] Cancel Reservation Location Change',
  emptyProps
);

export const returnFromReservationLocationChange = createAction(
  '[Reservation] Return From Reservation Location Change',
  emptyProps
);

// kdyz se nepovede nacist event z O365 - nejspise z duvodu jineho usera
export const loadCalendarEventFailed = createAction('[Reservation] Calendar Event failed');

export const loadReservationDetail = createAction(
  '[Reservation] Load ReservationDetail',
  props<{
    eventDetail: any;
    preserveCurrentDetail?: boolean;
    skipNavigation?: boolean;
    preserveLocationChangeState?: boolean;
  }>()
);

export const reservationDetailLoadSuccess = createAction(
  '[Reservation] ReservationDetail Load success',
  props<{ detail: IReservationDetail; preserveLocationChangeState?: boolean }>()
);

export const reservationDetailLoadFailed = createAction(
  '[Reservation] ReservationDetail Load failed',
  props<{ error: string; preserveLocationChangeState?: boolean }>()
);

export const outlookReservationModeChange = createAction(
  '[Reservation] OutlookReservationMode Change',
  props<{ reservationMode: OutlookReservationMode }>()
);
